import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportDto } from './reporting.model';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private httpClient = inject(HttpClient);

    list(): Observable<ReportDto[]> {
        return this.httpClient.get<ReportDto[]>('api/common/reports');
    }

    getByKey(reportKey: number): Observable<ReportDto> {
        return this.httpClient.get<ReportDto>(`api/common/reports/${reportKey}`);
    }
}
